import fwUtil from 'framework-util'
export const generalFieldService = new fwUtil.ApiService.ApiService('generalField');

export function saveAllService(tableId, data) {

  return custemRequest({
    url: 'generalField/saveAll/tableId/' + tableId,
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/generator/generator/generalField.js